import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'
import { Modal, ModalHeader } from 'reactstrap'

export const ModalWrapper = styled(Modal)`
  .modal-content {
    border-radius: 0;
    border: none;
    @media screen and (max-width: 575.98px) {
      text-align: center;
    }
  }
  .modal-header {
    border: none;
  }
  .modal-footer {
    width: 100%;
    justify-content: center;
    padding-top: 1.5rem;
    padding-bottom: 0;
  }
`

export const StyledModalHeader = styled(ModalHeader)`
  border: none;
`

export const ModalTitle = styled.h4`
  font-family: ${Theme.fonts.Montserrat};
  color: ${Theme.colors.primary};
  font-weight: 600;
  padding-left: 10px;
  padding-right: 10px;
`

export const ModalBody = styled.p`
  font-family: ${Theme.fonts.ProximaNova};
  font-weight: 500;
  font-size: 16px;
  padding-left: 25px;
  padding-right: 25px;
`

export const SpinnerWrapper = styled.div`
  padding-left: 25px;
  padding-bottom: 15px;
`
